import React from "react";
import { useInView } from "react-intersection-observer";
import ModelListCard from "./ModelListCard";
import ModelColorItemInterface from "../../interfaces/model/ModelColorItemInterface";

interface ModelListCardObserverProps {
  modelColorItem: ModelColorItemInterface;
  onInViewChange: (id: number, inView: boolean) => void;
  isPlaying: boolean;
  onVideoEnd: () => void; 
}

const ModelListCardObserver: React.FC<ModelListCardObserverProps> = ({ modelColorItem, onInViewChange, isPlaying, onVideoEnd  }) => {
  const { ref, inView } = useInView({
    threshold: 0.7,
    triggerOnce: false,
    delay: 200,
  });

  React.useEffect(() => {
    onInViewChange(modelColorItem.id, inView);
  }, [inView, modelColorItem.id, onInViewChange]);

  return (
    <div ref={ref} className="model-list-card">
      <ModelListCard modelColorItem={modelColorItem} inView={inView} isPlaying={isPlaying} onVideoEnd={onVideoEnd} />
    </div>
  );
};

export default ModelListCardObserver;